import styled from '@emotion/styled';
import { Button } from 'react-bootstrap';

export const COLUMN_BACKGROUND = '#f8f9fa';
export const MAX_DIMENSION = 14400; // jsPDF max dimension limit in px
export const IMAGE_QUALITY = 1;
export const PAGE_WIDTH = 600;
export const PAGE_HEIGHT = 400;
export const Container = styled('div')`
    overflow-x: auto;
    width: 100%;
    border: 1px solid #ccc;
    margin-bottom: 48px;
`;

export const Table = styled('div')`
    display: table;
    width: max-content;
    border-collapse: collapse;
`;

export const Row = styled('div')`
    display: table-row;
`;

export const Cell = styled('div')`
    display: table-cell;
    padding: 6px 8px;
    border: 1px solid #eee;
    white-space: nowrap;
    vertical-align: middle;
    font-weight: ${({ bold }) => (bold ? '600' : 'normal')};
    background: ${({ highlight }) => (highlight ? COLUMN_BACKGROUND : '#fff')};
    // width: 300px;
    // min-width: 300px;
    max-width: 300px;
    height: auto;
    white-space: normal;
    word-wrap: break-word;
    overflow: visible;
`;

export const HeaderCell = styled(Cell)`
    font-weight: 600;
    background: #f8f9fa;
    // width: 300px;
    // min-width: 300px;
    max-width: 300px;
`;

export const StickyCell = styled(Cell)`
    position: sticky;
    border-right: 1px solid #dee2e6;
    border-bottom: 1px solid #dee2e6;
    z-index: ${({ zIndex }) => zIndex || 2}px;
    left: ${({ left }) => left}px;
    background: ${({ sticky, header }) => (sticky || header ? COLUMN_BACKGROUND : '#fff')};
    font-weight: ${({ sticky, header }) => (sticky || header ? '600' : 'normal')};
    // width: 300px;
    // min-width: 300px;
    max-width: 300px;
`;
export const CellText = styled('div')`
    font-weight: ${({ bold }) => (bold ? '600' : 'normal')};
`;

export const TableTitle = styled('h3')`
    margin: 0 0 12px 0;
    font-size: 18px;
    color: #333;
    display: flex;
    align-items: center;
    gap: 12px;
    font-weight: 600;
`;

export const ToggleButton = styled(Button)`
    background: #6c757d !important;
    color: white;
    border: none !important;
    cursor: pointer;
    margin-left: 8px;
`;

export const Filters = styled('div')`
    border: 2px solid #dee2e6;
    padding: 16px;
    margin-bottom: 32px;
    border-radius: 3px;
    font-weight: 600;
    width: max-content;
`;
